module.exports = __webpack_public_path__ + "static/media/1POLICY8.ea60e4be.jpg";